export default {
    // dev server
    SERVER_URL: 'https://interface.recycletek.ddns.net',
    // local server
    // SERVER_URL: "http://localhost:5000",
    // SERVER_URL: "https://interface.recycletek.co"
};

